import { Component, AfterViewInit, OnDestroy, ElementRef } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { Router } from '@angular/router';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-employee-actions',
    templateUrl: './employee-actions.component.html',
    styleUrls: ['./employee-actions.component.css']
})
export class EmployeeActionsComponent implements AfterViewInit, OnDestroy {
    private tooltips: any[] = [];
    public cellValue!: any;

    constructor(
        private router: Router,
        private el: ElementRef<HTMLElement>,
        private permissionService: PermissionService,
    ) { }

    canDo(action: string): boolean {
        return this.permissionService.canDo('Listado de colaboradores', action);
    }

    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        this.cellValue = params;
    }

    // gets called whenever the user gets the cell to refresh
    refresh(params: ICellRendererParams): boolean {
        this.cellValue = params;
        return true;
    }

    ngAfterViewInit(): void {
        // Inicializa los tooltips de Bootstrap 5 para los iconos de esta celda
        const tooltipTriggerList = Array.from(
            this.el.nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]')
        ) as HTMLElement[];
        this.tooltips = tooltipTriggerList.map(el => new Tooltip(el));
    }

    ngOnDestroy(): void {
        // Libera los tooltips para evitar fugas de memoria cuando ag-grid destruye la celda
        this.tooltips.forEach(t => t.dispose());
        this.tooltips = [];
    }

    goToPayroll(): void {
        const id = this.cellValue?.data?.id;
        if (!id) return;
        // TODO Fase 2.4: navegar a /employee/{id}/payroll cuando exista esa ruta.
        this.router.navigateByUrl(`/employee/${id}`);
    }

    registerIncident(): void {
        const id = this.cellValue?.data?.id;
        if (!id) return;
        this.router.navigateByUrl(`/employee/${id}/incidents`);
    }

    get isTerminated(): boolean {
        return this.cellValue?.data?.status === 'terminated';
    }

    /** "Nómina del colaborador" solo es relevante una vez que se realizó al menos un cierre de nómina. */
    get hasClosedPeriod(): boolean {
        return !!this.cellValue?.context?.componentParent?.hasClosedPeriod;
    }

    dischargeEmployee(): void {
        const data = this.cellValue?.data;
        if (!data?.id || this.isTerminated) return;

        // El listado (EmployeeListComponent) expone su instancia como context.componentParent
        // porque este cell renderer se declara en AppModule y no puede acceder al template
        // del EmployeeModule directamente.
        const componentParent = this.cellValue?.context?.componentParent;
        if (componentParent && typeof componentParent.openTerminationModal === 'function') {
            componentParent.openTerminationModal(data);
        }
    }
}
